import React from "react";
import { SourceListPanel } from "../../document/sourceListPanel/SourceListPanel";
import { DocumentPartTreeSelection } from "../DocumentPartTree";
import { useSourceListPage } from "./SourcesListPanelLoaderHook";
import { DocumentPart } from "../../../api/models";

interface DocumentSourceListPageProps {
  headerName: string;
  documentPartTreeSelection: DocumentPartTreeSelection;
  documentPart: DocumentPart;
}
export const SourcesListPanelLoader: React.FunctionComponent<DocumentSourceListPageProps> = (props) => {
  const { documentSourceList } = useSourceListPage(props);

  return <SourceListPanel headerName={props.headerName} sourceList={documentSourceList} />;
};
